import React from "react";
import { string, objectOf, oneOfType, number, arrayOf, node, bool } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Link as LinkComponent } from "../../Link";
import { Icon } from "../../../components/Icons";
import * as styles from "./CardLink.module.scss";

const CardLink = ({ className, style, children, to, target, withoutIcon, iconSize }) => (
	<LinkComponent to={to} target={target} className={cx(styles.link, className)} style={style}>
		{children}
		{!withoutIcon && <Icon name="arrow-right" className={cx(iconSize)} />}
	</LinkComponent>
);

CardLink.propTypes = {
	children: oneOfType([arrayOf(node), node]),
	to: string.isRequired,
	target: string,
	iconSize: string,
	className: string,
	style: objectOf(oneOfType([string, number])),
	withoutIcon: bool,
};

CardLink.defaultProps = {
	children: undefined,
	style: {},
	target: "",
	className: "",
	withoutIcon: false,
	iconSize: "",
};

export default CardLink;
export { CardLink };
